/* eslint-disable */
import React from 'react'
import './Loading.css'
export default function Loading(){
    return <div className="content w-full justify-center items-center shadow-lg rounded-lg flex flex-col"><div className="lds-ring"><div></div><div></div><div></div><div></div></div></div>
}